import { useState } from "react";
import React from "react";
import { Link } from "react-router-dom";
import { Form } from "react-bootstrap";
import { Card, CardBody, Col, Container, Input, Row } from "reactstrap";
import { toast } from "react-toastify";
import lightLogo from "../../assets/images/light-logo.png";
import darkLogo from "../../assets/images/dark-logo.png";
import resetPasswordImage from "../../assets/images/auth/reset-password.png";
import { forgotPassword } from "../../services/authService";

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const ForgotPassword = () => {
  document.title = "Recuperar Password | Recruitment";

  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!emailRegex.test(email.trim())) {
      toast.error("Informe um email valido.");
      return;
    }

    setIsLoading(true);

    try {
      await forgotPassword(email.trim());
      setIsSubmitted(true);
      toast.success("Se o email existir, enviamos o link de recuperacao.");
    } catch (error) {
      console.error("[auth] Erro ao solicitar reset de password", error);
      toast.error(error.message || "Erro ao solicitar recuperacao de password.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <React.Fragment>
      <div className="main-content">
        <div className="page-content">
          <section className="bg-auth">
            <Container>
              <Row className="justify-content-center">
                <Col xl={10} lg={12}>
                  <Card className="auth-box">
                    <Row className="g-0">
                      <Col lg={6} className="text-center">
                        <CardBody className="p-4">
                          <Link
                            className="text-dark fw-bold fs-3 mx-auto d-flex align-items-center justify-content-center gap-2"
                            to="/"
                          >
                            <img src={lightLogo} alt="" height="30" className="logo-dark" />
                            <img src={darkLogo} alt="" height="30" className="logo-light" />
                            Recruitment
                          </Link>
                          <div className="mt-5">
                            <img src={resetPasswordImage} alt="" className="img-fluid" />
                          </div>
                        </CardBody>
                      </Col>

                      <Col lg={6}>
                        <CardBody className="auth-content p-5 h-100 text-white">
                          <div className="text-center mb-4">
                            <h5>Esqueceu a Password?</h5>
                            <p className="text-white-50 mb-0">
                              Envie o seu email para receber o link de recuperacao.
                            </p>
                          </div>

                          {isSubmitted ? (
                            <div className="alert alert-success" role="alert">
                              Pedido enviado. Verifique a sua caixa de entrada e spam.
                            </div>
                          ) : null}

                          <Form className="auth-form text-white" onSubmit={handleSubmit}>
                            <div className="mb-4">
                              <label className="form-label" htmlFor="recoveryEmail">
                                Email
                              </label>
                              <Input
                                type="email"
                                className="form-control"
                                id="recoveryEmail"
                                placeholder="Digite o seu email"
                                value={email}
                                onChange={(event) => setEmail(event.target.value)}
                                required
                                disabled={isLoading}
                              />
                            </div>

                            <div className="mt-3">
                              <button type="submit" className="btn btn-white w-100" disabled={isLoading}>
                                {isLoading ? "Enviando..." : "Enviar Link de Recuperacao"}
                              </button>
                            </div>
                          </Form>

                          <div className="mt-5 text-center text-white-50">
                            <p className="mb-0">
                              Lembrou da senha?{" "}
                              <Link
                                to="/signin"
                                className="fw-medium text-white text-decoration-underline"
                              >
                                Voltar para login
                              </Link>
                            </p>
                          </div>
                        </CardBody>
                      </Col>
                    </Row>
                  </Card>
                </Col>
              </Row>
            </Container>
          </section>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ForgotPassword;
